<template>
    <transition name="slide-in-fade">
        <section v-if="showNotification">
            <div class="notification-container">
                <p>Task Pick-Up Success!</p>
            </div>
            <div style="height: 40px;"></div>
        </section>
    </transition>
</template>

<script>
export default {
    props: ['display'],

    data () {
        return {
            showNotification: false,
            timer: null,
        };
    },

    watch: {
        display () {
            this.showNotification = true;

            this.timer = setTimeout(this.timerFunc, 5000);
        },
    },

    methods: {
        timerFunc () {
            clearTimeout(this.timer);
            this.showNotification = false;
        }
    }
};
</script>

<style scoped lang="scss">
.notification-container {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    background-color: #2ecc71;

    p {
        color: #fff;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
        margin: 0;
    }
}

.slide-in-fade-enter-active {
    transition: all .3s ease;
}

.slide-in-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-in-fade-enter, .slide-in-fade-leave-to {
    opacity: 0;
}
</style>
